import * as React from 'react';
import { useQuery } from '@apollo/client';
import { useParams } from 'react-router-dom';

import { GET_PROPERTY_NYBYGG_PROFILE_QUERY } from '../../../client/__graphql__/queries/getPropertyNybyggProfile';

import {
  GetPropertyNybyggProfile,
  GetPropertyNybyggProfileVariables,
} from '../../__types__/generated/GetPropertyNybyggProfile';
import { ThemeRoute } from '../utils/ThemeRoute';
import NoMatch from './NoMatch';
import Index from './nybygg/Index';

const NybyggProfile: React.FC<{ preview: boolean }> = ({ preview }) => {
  const params = useParams<{ sguid: string }>();

  const { data, loading, error } = useQuery<
    GetPropertyNybyggProfile,
    GetPropertyNybyggProfileVariables
  >(GET_PROPERTY_NYBYGG_PROFILE_QUERY, {
    fetchPolicy: 'cache-only',
    variables: preview
      ? { input: { sguid: params?.sguid, preview: true } }
      : { input: { sguid: params?.sguid } },
  });

  if (loading) {
    return null;
  }

  if (error?.graphQLErrors?.length && error.graphQLErrors?.length > 0) {
    if (error.graphQLErrors[0]?.extensions?.code === '404') {
      return <NoMatch />;
    }
  }

  const commonRoutePath = preview
    ? '/:page(preview)/:sguid'
    : '/:urltag/:sguid/:permalink';
  /* Hvit side */
  if (data?.profile?.nybygg?.profile === 2) {
    return (
      <ThemeRoute
        exact
        themeName="nybyggLightOld"
        path={commonRoutePath}
        Component={Index}
      />
    );
  } else {
    return (
      <ThemeRoute
        exact
        themeName="nybyggDarkOld"
        path={commonRoutePath}
        Component={Index}
      />
    );
  }
};

export default NybyggProfile;
